export default "__VITE_PUBLIC_ASSET__56563211__"